// Espelha o enum Permissao do backend (br.com.japmetais.sijap.enums.Permissao).
// Os valores devem bater exatamente com Permissao.name(), que é o que a API
// retorna no login e recebe em requiredPermission.
const Permissoes = Object.freeze({
  ALMOXARIFADO: 'Almoxarifado',
  ALMOXARIFADO_CADASTRO: 'AlmoxarifadoCadastro',
  APROVA_SC: 'AprovaSC',
  DOCUMENTO_CADASTRO: 'DocumentoCadastro',
  EPI: 'EPI',
  EPI_CADASTRO: 'EPICadastro',
  FEED: 'Feed',
  FINANCEIRO: 'Financeiro',
  FLUXO_CAIXA: 'FluxoCaixa',
  FUNCIONARIO: 'Funcionario',
  FUNCIONARIO_CADASTRO: 'FuncionarioCadastro',
  MEDICAO: 'Medicao',
  MERCADORIA: 'Mercadoria',
  MERCADORIA_CADASTRO: 'MercadoriaCadastro',
  ORDEM_SERVICO: 'OrdemServico',
  PROPOSTA_COMERCIAL: 'PropostaComercial',
  RELATORIO: 'Relatorio',
  RELATORIO_VEICULO: 'RelatorioVeiculo',
  ROMANEIO: 'Romaneio',
  SC: 'SC',
  SC_ORCAMENTO: 'SCOrcamento',
  SETOR: 'Setor',
  TI: 'TI',
  VEICULO: 'Veiculo',
  VEICULO_CADASTRO: 'VeiculoCadastro',
});

export default Permissoes;
